import styled from "styled-components";
import Layout from "../../../custom/Layout";
import { Table } from "reactstrap";
import MawbInput from "../../../custom/MawbInput";
import { useEffect, useMemo, useState } from "react";
import useTypedForm from "../../../custom/hookForm/useTypedForm";
import { ButtonGroup } from "reactstrap";
import { Button } from "reactstrap";
import { Input } from "reactstrap";
import ActionIcon from "../../../custom/ActionIcon";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string, number } from 'yup';
import { formatMawb, getGuid, getTsDate, getUnitedDate, getUnitedLocation, notify, validateAwb } from "../../../../utils";
import { useRecoilValue } from "recoil";
import { unitedScannerIdState } from "../../../../globals/atoms";
import useUser from "../../../../customHooks/useUser";
import VirtualTable from "../../../custom/VirtualTable";
import WholeNumberInput from "../../../WholeNumberInput";
import useUnitedRoleRegister from "../Buildup/useUnitedRoleRegister";
import { LoadingUnitedRegistration } from "../Buildup/TruckBuildup";
import { apiClientEosNative } from "../../../../apiClient";
import _ from "lodash";
import { ZodType, z } from "zod";
import LoadingButton from "../../../LoadingButton";
import { Label } from "reactstrap";
import { FormGroup } from "reactstrap";
import RenderUlds from "./RenderUlds";
import useModal from "../../../../customHooks/useModal";
import ModalUld from "./ModalUld";
import { IFFMSchemaType, postDataSchema, PostDataSchema } from "./postDataSchema";
import useAirportCodes from "../../../../customHooks/useAirportCodes";
import { defaultOtherData, formatFlightNumber } from "./utils";
import moment from "moment";

export interface Uld {
    key: string;
    uld: string;
    data: Array<IFFMSchemaType>;
}

export type UldArray = Array<Uld>;

export default function CreateTransferExport() {

    const { ready } = useUnitedRoleRegister();
    const { user } = useUser();
    const scannerId = useRecoilValue(unitedScannerIdState);
    const now = getTsDate();
    const { airportCodes, airportCodesMap } = useAirportCodes();
    const [otherData, setOtherData] = useState({
        truckNumber: ''
    });
    const [loading, setLoading] = useState(false);
    const [uldArray, setUldArray] = useState<UldArray>([]);
    const [uldKey, setUldKey] = useState<string | null>(null);
    const [validData, setValidData] = useState(false);
    const { modal: modalUld, setModal: setModalUld } = useModal();
    const selectedUld = uldArray.find(item => _.get(item, 'key', '') === uldKey);

    const postData = useMemo(() => {
        if (!uldArray) return {};

        const ffms: Array<IFFMSchemaType> = [];
        const { truckNumber } = otherData;
        const { s_email, s_unit } = user;

        for (const { data } of uldArray) {
            if (!data || !data.length) return {};
            for (const item of data) {
                ffms.push(item);
            }
        }

        const data: PostDataSchema = {
            united: {
                userId: _.get(user, 'additionalData.unitedVNumber', null),
                name: user.displayName,
                scanDateTime: getTsDate(),
                scannedCode: '',
                numberOfPiecesInCargo: '',
                scannerId,
                scannedLoc: getUnitedLocation({
                    s_unit,
                    breakdownAcceptance: true,
                    load: false,
                    dockDoor: 0,
                    truckName: '',
                    overrideLocation: formatFlightNumber(Number(truckNumber))
                })
            },
            ffms,
            other: {
                s_unit,
                s_email,
                date: moment().format('YYYY-MM-DD')
            }
        };

        return data;
    }, [user, otherData, uldArray]);

    useEffect(() => {
        const result = postDataSchema.safeParse(postData);
        setValidData(result.success); // ✅ Update state based on validation result
    }, [postData]); // ✅ Runs whenever `data` changes

    const handleCreateUpdateUld = (uldKey?: string) => {
        setUldKey(uldKey || null);
        setModalUld(true);
    }

    const submitData = async () => {
        postDataSchema.parse(postData);

        setLoading(true);
        try {
            await apiClientEosNative.post(`/truck-buildup/export`, postData);
            notify('Data submitted');
            setUldArray([]);
            setOtherData(defaultOtherData);
        } catch (err) {
            alert(err);
        } finally {
            setLoading(false);
        }
    }

    if (!ready) {
        return (
            <Layout>
                <LoadingUnitedRegistration />
            </Layout>
        );
    }

    return (
        <div>
            <FlexContainer>
                <div>
                    <h3><RightArrow /> Enter ULDs</h3>
                    <RenderUlds
                        uldArray={uldArray}
                        setUldArray={setUldArray}
                        uldKey={uldKey}
                        setUldKey={setUldKey}
                        selectedUld={selectedUld}
                        handleCreateUpdateUld={handleCreateUpdateUld}
                        airportCodes={airportCodes}
                        airportCodesMap={airportCodesMap}
                        now={now}
                    />
                </div>
                {
                    validData && (
                        <div>
                            <h3><RightArrow /> Submit Manifest</h3>
                            <ActionIcon
                                type={'save'}
                                onClick={submitData}
                                loading={loading}
                            />
                        </div>
                    )
                }
            </FlexContainer>
            <ModalUld
                modal={modalUld}
                setModal={setModalUld}
                uldArray={uldArray}
                setUldArray={setUldArray}
                selectedUld={selectedUld}
            />
        </div>
    );
}

const RightArrow = () => {
    return (
        <i className="fa-solid fa-arrow-right"></i>
    );
}

const FlexContainer = styled.div`
    display: flex;
    gap: 25px;

    &:nth-child(2) {
        flex: 1;
    }
`;
